import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  sqls: [],
  sqlsSelected: []
};

const getters = {
  // Projeto
  sqls: state => state.sqls.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  sqlsAtivo: state => state.sqls.filter(s => s.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  sqlsSelected: state => state.sqlsSelected
}

const actions = {
  async fetchSqls({ commit }, args) {
    const response = await axios.get(`${baseUrl}/sqls`);
    if (response.data.length) {
      const data = response.data.filter(sql => sql.Status.includes(args.status));
      commit('setSqls', data);
    } else {
      commit('setSqls', []);
    }
  },
  async fetchSqlById({ commit }, id) {
    const response = await axios.get(`${baseUrl}/sqls/${id}`);

    if (response.data.length) {
      commit('setSqls', response.data);
      return response.data[0];
    } else {
      commit('setSqls', []);
    }
  },
  async addSql({ commit }, sql) {
    const response = await axios.post(`${baseUrl}/sqls`, sql, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    sql.IdSql = response.data.IdSql;
    commit('newSql', sql);
    return response.data.IdSql;
  },
  async updateSql({ commit }, updSql) {
    await axios.put(`${baseUrl}/sqls`, updSql, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateSql', updSql);
  },
  async deleteSql({ commit }, id) {
    await axios.delete(`${baseUrl}/sqls/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeSql', id);
  },
  async selectSqls({ commit }, sqls) {
    commit('newSqlSelected', sqls);
  },
  async resetSqlsSelected({ commit }) {
    commit('resetSqlsSelected');
  },
}

const mutations = {
  // Sql
  setSqls: (state, sqls) => state.sqls = sqls,
  newSql: (state, sql) => state.sqls.push(sql),
  removeSql: (state, id) => state.sqls = state.sqls.filter(sql => sql.IdSql !== id),
  updateSql: (state, updSql) => {
    const index = state.sqls.findIndex(sql => sql.IdSql === updSql.IdSql);
    if (index !== -1) {
      state.sqls.splice(index, 1, updSql);
    }
  },
  newSqlSelected: (state, sqls) => state.sqlsSelected = sqls,
  resetSqlsSelected: state => state.sqlsSelected = [],
}

export default {
  state,
  getters,
  actions,
  mutations
}